export default __webpack_public_path__ + "/dist/images/italian-contentimg-3.ea93a904d85becea99d68142a554ac1e.png";